import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_INVOICE_CLIENT_ID_LOADING = 'GET_INVOICE_CLIENT_ID_LOADING';
export const GET_INVOICE_CLIENT_ID_SUCCESS = 'GET_INVOICE_CLIENT_ID_SUCCESS';
export const GET_INVOICE_CLIENT_ID_REJECT  = 'GET_INVOICE_CLIENT_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getInvoiceClientIdLoading = () => ({ type: GET_INVOICE_CLIENT_ID_LOADING });
export const getInvoiceClientIdSuccess = (payload) => ({ type: GET_INVOICE_CLIENT_ID_SUCCESS, payload });
export const getInvoiceClientIdReject  = (payload) => ({ type: GET_INVOICE_CLIENT_ID_REJECT,  payload });

//* REQUEST SERVICE ----------------------------------------
export const getInvoiceClientIdRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Invoices/web/GetInvoicesById`, options);
};
